import { useWatch } from 'react-hook-form';
import React from 'react';
import { useIntegratedForm } from '../../../../forms/use-integrated-form';
import { EntityPanelFormVehicleBaseKey, EntityPanelVehiclesForm } from '../types';
import { FormVehicleMakeSelect } from '../../../../forms/integrated-form-controls/form-vehicle-make-select';
import { FormInput } from '../../../../forms/integrated-form-controls/form-input';
import { FormVehicleModelSelect } from '../../../../forms/integrated-form-controls/form-vehicle-model-select';
import { OtherField } from './entity-panel-form-vehicles-other-field';

interface EntityPanelMakeAndModelFieldsProps {
    index: number;
    baseKey: EntityPanelFormVehicleBaseKey;
    isPersisted: boolean;
    length?: 'sm' | 'md' | 'lg';
    isReadOnly?: boolean;
}

export function EntityPanelMakeAndModelFields(
    props: EntityPanelMakeAndModelFieldsProps
): React.ReactElement {
    const { form } = useIntegratedForm<EntityPanelVehiclesForm>();

    const vehicleMake = useWatch({
        control: form.control,
        name: `${props.baseKey}.${props.index}.vehicleMakeOption`,
    });

    return (
        <>
            <FormVehicleMakeSelect
                control={form.control}
                label="Make"
                name={`${props.baseKey}.${props.index}.vehicleMakeOption`}
                asEditable={!!props.isPersisted}
                length={props.length ?? 'md'}
                eventNotificationName="TOW_VEHICLE_MAKE"
                mode={props.isReadOnly ? 'read-only' : undefined}
            />

            <OtherField
                watchPath={`${props.baseKey}.${props.index}.vehicleMakeOption`}
                otherPath={`${props.baseKey}.${props.index}.vehicleMakeOther`}
            >
                <FormInput
                    control={form.control}
                    label="Make Description"
                    name={`${props.baseKey}.${props.index}.vehicleMakeOther`}
                    asEditable={!!props.isPersisted}
                    length={props.length ?? 'md'}
                    mode={props.isReadOnly ? 'read-only' : undefined}
                />
            </OtherField>
            <FormVehicleModelSelect
                control={form.control}
                label="Model"
                name={`${props.baseKey}.${props.index}.vehicleModelOption`}
                asEditable={!!props.isPersisted}
                vehicleMakeId={vehicleMake?.value}
                eventNotificationName="TOW_VEHICLE_MODEL"
                length={props.length ?? 'md'}
                mode={props.isReadOnly ? 'read-only' : undefined}
            />

            <OtherField
                watchPath={`${props.baseKey}.${props.index}.vehicleModelOption`}
                otherPath={`${props.baseKey}.${props.index}.vehicleModelOther`}
            >
                <FormInput
                    control={form.control}
                    label="Model Description"
                    name={`${props.baseKey}.${props.index}.vehicleModelOther`}
                    asEditable={!!props.isPersisted}
                    length={props.length ?? 'md'}
                    mode={props.isReadOnly ? 'read-only' : undefined}
                />
            </OtherField>
        </>
    );
}
